var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({class:_vm.svgClass,attrs:{"width":_vm.sizes[0],"height":_vm.sizes[1],"fill":"currentcolor","aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }